import {
  firestore, storage, apiEndpoint, functions,
} from '@/extern/firebase';
import store from '@/store';

const COLLECTION = 'assignments';
const storeRef = firestore.collection(COLLECTION);
const fileRef = storage.ref('assignments');

type FirestoreDoc = firebase.firestore.DocumentSnapshot<firebase.firestore.DocumentData>

export interface Assignment {
  id?: string;
  title?: string;
}

export interface SubmissionFile {
  name?: string;
  path?: string;
}
export interface Submission {
  id?: string;
  name?: string;
  files?: Array<SubmissionFile>;
}

function toAssignment(
  doc: FirestoreDoc,
): Assignment {
  return {
    id: doc.id,
    ...doc.data(),
  };
}

function getUserId(): string {
  return store.getters.user.data.uid;
}

export async function getAssignmentList(): Promise<Array<Assignment>> {
  const result = new Array<Assignment>();
  const query = await storeRef.where('author', '==', getUserId()).get();
  query.forEach((doc) => {
    result.push(toAssignment(doc));
  });

  return result;
}

export async function getAssignment(id: string): Promise<Assignment> {
  const query = await storeRef.doc(id).get();
  if (query.exists) {
    return toAssignment(query);
  }
  throw new Error('404');
}

export async function addAssignment(ass: Assignment): Promise<string> {
  const doc = await storeRef.add({
    ...ass,
    author: getUserId(),
  });
  return doc.id;
}

export async function deleteAssignment(assignment: Assignment) {
  const fn = functions.httpsCallable('deleteAssignment');
  return fn({
    id: assignment.id,
  });
}

function getSubmissionRef(assignment: Assignment) {
  return storeRef.doc(assignment.id).collection('submission');
}

function toSubmission(doc: FirestoreDoc): Submission {
  return {
    id: doc.id,
    ...doc.data(),
  };
}

export async function getSubmissionList(assignment: Assignment) {
  const result = Array<Submission>();
  const query = await getSubmissionRef(assignment).get();
  query.forEach((doc) => {
    result.push(toSubmission(doc));
  });

  return result;
}

export async function addSubmission(assignment: Assignment, name: string, files: Array<File>) {
  const data: Submission = {
    name,
  };
  const doc = await getSubmissionRef(assignment).add(data);

  try {
    const folder = fileRef.child(`${assignment.id}/${doc.id}`);
    data.files = new Array<SubmissionFile>();
    for (let index = 0; index < files.length; index += 1) {
      const value = files[index];
      const fileName = `${index}. ${value.name}`;
      const ref = folder.child(fileName);
      console.log(ref.fullPath);
      // eslint-disable-next-line  no-await-in-loop
      await ref.put(value);
      data.files.push({
        name: fileName,
        path: ref.fullPath,
      });
    }

    await doc.set(data);
  } catch (e) {
    await doc.delete();
    throw e;
  }
}

export function getDownloadSubmissionAsZipURL(assignment: Assignment) {
  return `${apiEndpoint}/donwloadSubmissionAsZip?id=${assignment.id}`;
}

export function getSubmitLink(assignment: Assignment) {
  return `${window.location.origin}/submit/${assignment.id}`;
}
